import { Page as ApiPage } from 'api/cms';
import {
  PublicPage as ApiPublicPage,
  fetchPage as apiFetchPublicPage,
} from 'api/website';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch, GetState } from '..';
import { setError } from './error';

// Types

export type PageStates = 'UNFETCHED' | 'SUCCESS' | 'NOT_FOUND' | 'FETCHING';
export type Content = {
  type: string;
  content: ApiPublicPage;
};
export type Page = ApiPublicPage;
export type State = {
  byUrl: Record<
    string,
    Content & {
      state: 'SUCCESS' | 'NOT_FOUND' | 'FETCHING';
    }
  >;
};

type FetchPageRequestAction = {
  type: 'FETCH_PAGE_REQUEST';
  url: string;
};
type FetchPageSuccessAction = {
  type: 'FETCH_PAGE_SUCCESS';
  content: {
    content: ApiPage;
    type: string;
  };
  url: string;
};
type FetchPageFailureAction = {
  type: 'FETCH_PAGE_FAILURE';
  url: string;
};
export type Action =
  | FetchPageRequestAction
  | FetchPageSuccessAction
  | FetchPageFailureAction;

// Reducer

const defaultState = {
  byUrl: {},
};

export default function contentsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = defaultState,
  action: Action
) {
  switch (action.type) {
    case 'FETCH_PAGE_REQUEST':
      return {
        ...state,
        byUrl: {
          ...state.byUrl,
          [action.url]: { ...state.byUrl[action.url], state: 'FETCHING' },
        },
      };

    case 'FETCH_PAGE_SUCCESS': {
      return {
        ...state,
        byUrl: {
          ...state.byUrl,
          [action.url]: {
            ...state.byUrl[action.url],
            ...action.content,
            state: 'SUCCESS',
          },
        },
      };
    }

    case 'FETCH_PAGE_FAILURE': {
      return {
        ...state,
        byUrl: {
          ...state.byUrl,
          [action.url]: { ...state.byUrl[action.url], state: 'NOT_FOUND' },
        },
      };
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never;

      return state;
  }
}

// Actions

const fetchPageRequest = (url: string): FetchPageRequestAction => ({
  type: 'FETCH_PAGE_REQUEST',
  url,
});

const fetchPageSuccess = (
  content: {
    content: ApiPage;
    type: string;
  },
  url: string
): FetchPageSuccessAction => ({
  type: 'FETCH_PAGE_SUCCESS',
  content,
  url,
});

const fetchPageFailure = (url: string): FetchPageFailureAction => ({
  type: 'FETCH_PAGE_FAILURE',
  url,
});

export const fetchPage =
  (pageUrl: string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const content = state.contents.byUrl[pageUrl];

    if (!content) {
      dispatch(fetchPageRequest(pageUrl));
      apiFetchPublicPage(pageUrl)
        .then((fetchedPage) => {
          dispatch(
            fetchPageSuccess(
              {
                content: fetchedPage.data,
                type: fetchedPage.type,
              },
              pageUrl
            )
          );
        })
        .catch((e) => {
          if (e.statusCode === 404) {
            dispatch(fetchPageFailure(pageUrl));
          } else {
            dispatch(setError(e));
          }
        });
    }
  };
export const updatePage = fetchPageSuccess;
